export default __webpack_public_path__ + "staticlp3/media/advantages-devices-mobile.be14fbaf.png";